import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

// Dedicated client for the Employee Portal — uses a SEPARATE token key so the
// employee session is fully isolated from the admin session.
const empApi = axios.create({ baseURL: `${BASE}/api` });

empApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("cf_emp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const t = localStorage.getItem("cf_tenant");
  if (t) { try { const o = JSON.parse(t); if (o && o.slug) config.headers["X-Tenant"] = o.slug; } catch { /* ignore */ } }
  return config;
});

empApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.status === 401) {
      localStorage.removeItem("cf_emp_token");
      localStorage.removeItem("cf_emp");
      if (window.location.pathname.startsWith("/karyawan") && window.location.pathname !== "/karyawan/login") {
        window.location.href = "/karyawan/login";
      }
    }
    return Promise.reject(err);
  }
);

export default empApi;
